var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { useMemo } from "react";
import { sortBy, get } from 'lodash';
import { entityTypeNameFor } from "@shapeable/utils";
import { usePageEntity } from "./use-page-entity";
// another possibility here is to push this logic to the server, and have the server return the nodes and edges
export function useEntityNavigatorNodes(args) {
  var fieldNameChildren = args.fieldNameChildren,
    sort = args.sort,
    sortChildren = args.sortChildren;
  var activeEntity = usePageEntity();
  var activeTypeName = entityTypeNameFor(activeEntity);
  var isActiveNode = function (entity) {
    var entityTypeName = entityTypeNameFor(entity);
    return (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.id) === entity.id && activeTypeName === entityTypeName;
  };
  return useMemo(function () {
    var items = sort ? sortBy(args.items, sort) : args.items;
    return items.map(function (item) {
      var edgeFieldItems = get(item, fieldNameChildren, []);
      var edgeItems = sortChildren ? sortBy(edgeFieldItems, sortChildren) : edgeFieldItems;
      var isActiveSource = isActiveNode(item) || edgeItems.some(function (item) {
        return isActiveNode(item);
      });
      return __assign(__assign({}, item), {
        isActive: isActiveSource,
        edges: edgeItems.map(function (edgeItem) {
          // const topic = topics.find(topic => topic.id === topic.id);
          var isActive = isActiveNode(edgeItem);
          return {
            id: "edge__".concat(edgeItem.slug, "_").concat(edgeItem.slug),
            isActive: isActive && isActiveSource,
            node: __assign(__assign({}, edgeItem), {
              isActive: isActive,
              source: item
            })
          };
        })
      });
    });
  }, [args.items, activeEntity]);
}
;